export const showreel = {
  videoSrc: 'https://cdn.sanity.io/files/jkwxe35s/production/bcac39e72de2165f520b204e10b1552731c41d61.mp4',
};
